export async function convertFileToBase64(file: File): Promise<string> {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result?.toString() || '')
    reader.readAsDataURL(file)
  })
}
